import React, { useEffect, useState } from "react";
import { Container } from "shards-react";

// import ameBrand from '../../images/ame_brand.svg'
import InformationCard from "./components/information-card-component/InformationCard";

import "./invite-accept-screen.css";
import ErrorHandler from "../../utils/ErrorHandler";
import InviteService from "../../services/invite-service/InviteService";
import { useParams } from "react-router-dom";

const InviteAcceptScreen = () => {
    const [isFetching, setIsFetching] = useState(false);
    const [isValidToken, setIsValidToken] = useState(false);
    const [isApprovedSolicitation, setIsApprovedSolicitation] = useState(false);
    const [isDisapprovedSolicitation, setIsDisapprovedSolicitation] = useState(
        false
    );
    const [miniAppInformations, setMiniAppInformations] = useState({});
    const [token, setToken] = useState("");
    const params = useParams();

    useEffect(() => {
        if (params.token) {
            let token = params.token;
            setIsFetching(true);
            InviteService.findMiniApp(token)
                .then(res => {
                    setMiniAppInformations(res.data);
                    setIsValidToken(true);
                    setToken(params.token);
                })
                .catch(err => ErrorHandler.handleError(err))
                .finally(() => setIsFetching(false));
        }
    }, []);

    const acceptInvite = () => {
        setIsFetching(true);
        InviteService.acceptInvite(token)
            .then(() => setIsApprovedSolicitation(true))
            .catch(err => {
                ErrorHandler.handleError(err);
                setIsDisapprovedSolicitation(true);
            })
            .finally(() => setIsFetching(false));
    };

    const informations = {
        miniAppInformations,
        isValidToken,
        isFetching,
        isApprovedSolicitation,
        isDisapprovedSolicitation,
        history
    };
    const actions = {
        acceptInvite: acceptInvite
    };

    return (
        <div className="invite-accept--container">
            <div className="invite-accept--nav-bar">
                <span className="p-3">
                    <h1>Portal de Eitri-Apps</h1>
                </span>
            </div>
            <Container className="invite-accept--content-container">
                <InformationCard
                    informations={informations}
                    showBrand={false}
                    actions={actions}
                />
            </Container>
        </div>
    );
};

export default InviteAcceptScreen;
